import { render, staticRenderFns } from "./IconCourses.vue?vue&type=template&id=c678b3ba"
import script from "./IconCourses.vue?vue&type=script&lang=js"
export * from "./IconCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports